import React, { useMemo, useState } from "react";
import { Autocomplete, Button, TextField } from "@mui/material";

import { IInvestmentDetailField } from "store/types";
import { ITransformedChartConfig } from "store/types";
import { useDealActions } from "store";
interface IDefaultValue extends ITransformedChartConfig {}
interface Props {
  columns: IInvestmentDetailField[];
  defaultValue: IDefaultValue;
  onClose: () => void;
}

export const ChartMenu: React.FC<Props> = ({ columns, defaultValue, onClose }) => {
  const { setInvestmentDetailsChartAction } = useDealActions();

  const [state, setState] = useState<ITransformedChartConfig>(defaultValue);

  const groupByOptions: IInvestmentDetailField[] = useMemo(
    () => columns.filter((col) => col.column_type === "text"),
    [columns]
  );

  const valueByOptions = useMemo(() => {
    return columns.filter((col) => col.column_type !== "text");
  }, [columns]);

  const handleSubmit = () => {
    setInvestmentDetailsChartAction(state);
    onClose();
  };

  const defaultValueBy = useMemo(() => {
    return valueByOptions.find((col) => col.id === Number(state.valueBy)) || null; //added Number wrapper in case to avoid bug, server accept it as string in params of GET request
  }, [valueByOptions, state.valueBy]);

  const defaultGroupBy = useMemo(() => {
    return groupByOptions.find((col) => col.id === Number(state.groupBy)) || null;
  }, [groupByOptions, state.groupBy]);

  return (
    <>
      <Autocomplete
        defaultValue={defaultValueBy}
        getOptionLabel={(option: IInvestmentDetailField) => option.name}
        renderInput={(params) => <TextField {...params} label="Value" size="small" />}
        options={valueByOptions}
        onChange={(_, value) => {
          if (value) {
            setState({ ...state, valueBy: value.id });
          }
        }}
      />

      <Autocomplete
        defaultValue={defaultGroupBy}
        getOptionLabel={(option: IInvestmentDetailField) => option.name}
        renderInput={(params) => <TextField {...params} label="Group by" size="small" />}
        options={groupByOptions}
        onChange={(_, value) => {
          if (value) {
            setState({ ...state, groupBy: value.id });
          }
        }}
      />
      <Button sx={{ alignSelf: "flex-start" }} variant="contained" onClick={handleSubmit}>
        Apply
      </Button>
    </>
  );
};
